import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import translations from '@/data/translations';

const Footer = ({ products = [], settings = {} }) => {
  const { lang, getLocalizedPath, getLocalized } = useLanguage();
  const ft = translations.footer[lang];
  const contact = settings?.contact || {};

  const companyPaths = ['/about', '/#gallery', '/for-builders', '/for-architects', '/#catalog'];

  return (
    <footer className="bl-footer" data-testid="footer">
      <div className="bl-footer-grid">
        <div>
          <img src="/blackline-logo-cropped.png" alt="Blackline Premium Solutions" className="bl-footer-logo-img" />
          <p className="bl-footer-tagline">{ft.tagline}</p>
        </div>
        <div className="bl-footer-col">
          <h5>{ft.productsTitle}</h5>
          <ul>
            {products.map((p) => {
              const loc = getLocalized(p);
              return (
                <li key={p.slug}>
                  <Link to={getLocalizedPath(`/products/${p.slug}`)}>{loc.name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="bl-footer-col">
          <h5>{ft.companyTitle}</h5>
          <ul>
            {ft.companyLinks.map((label, i) => (
              <li key={i}>
                <Link to={getLocalizedPath(companyPaths[i] || '/')}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="bl-footer-col">
          <h5>{ft.contactTitle}</h5>
          <ul>
            <li style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)', marginBottom: '0.3rem' }}>1250 W Sam Houston Pkwy<br/>Houston, TX 77042</li>
            <li><a href="tel:+13466156860">(346) 615-6860</a></li>
            <li><a href="mailto:sales@blacklineps.com">sales@blacklineps.com</a></li>
            <li><a href="sms:+13466156860">SMS / Text</a></li>
            <li style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.3)', marginTop: '0.5rem' }}>{lang === 'es' ? 'Entregas en todo Texas' : 'Delivering across all of Texas'}</li>
          </ul>
        </div>
      </div>
      <div className="bl-footer-bottom">
        <span className="bl-footer-copy">{ft.copyright}</span>
        <div className="bl-footer-socials">
          <a href="https://instagram.com/blacklineps" target="_blank" rel="noopener noreferrer">IG</a>
          <a href="https://www.facebook.com/profile.php?id=61588789660882" target="_blank" rel="noopener noreferrer">FB</a>
          <a href={settings?.social?.houzz || '#'} target="_blank" rel="noopener noreferrer">Houzz</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
